import { render, staticRenderFns } from "./metodosPagoStripe.vue?vue&type=template&id=894f6148"
import script from "./metodosPagoStripe.vue?vue&type=script&lang=js"
export * from "./metodosPagoStripe.vue?vue&type=script&lang=js"
import style0 from "./metodosPagoStripe.vue?vue&type=style&index=0&id=894f6148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports